import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CustomerDetailsModel } from '../../../../shared/models/customers.model';
import { CustomersService } from '../../../../shared/services/customers.service';
import { SharedModule } from '../../../../shared/shared.module';
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton/skeleton.component";

@Component({
  selector: 'app-customer-details',
  standalone: true,
  imports: [SharedModule, SkeletonLoaderComponent],
  templateUrl: './customer-details.component.html',
  styleUrl: './customer-details.component.scss',
})
export class CustomerDetailsComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  customerDetails!: CustomerDetailsModel | null;
  isLoading = false;
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly customerService: CustomersService
  ) {}

  ngOnInit(): void {
    this.init();
  }
  init() {
    const sub = this.activatedRoute.paramMap.subscribe((data: any) => {
      if (data.get('id')) {
        this.getCustomerDetails(data.get('id'));
      }
    });
    this.subscription.add(sub);
  }

  getCustomerDetails(id: string) {
    this.isLoading = true;
    this.customerService.fetchCustomerDetails(id).subscribe({
      next: (data) => {
        this.isLoading = false;
        this.customerDetails = data?.data ?? null;
      },
      error: (error: any) => {
        console.log(error);
      },
    });
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
